import { render, staticRenderFns } from "./EllipseStatus.vue?vue&type=template&id=5406d7a2&scoped=true"
import script from "./EllipseStatus.vue?vue&type=script&lang=js"
export * from "./EllipseStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406d7a2",
  null
  
)

export default component.exports